import { Component, OnInit, OnDestroy, ViewChildren, QueryList, ViewChild, AfterViewInit, ChangeDetectorRef } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DataTableDirective } from 'angular-datatables';
import { skip } from "rxjs/operators";

import { OtherKpFilter } from '../../../models/other-kp-filter';
import { environment } from '../../../../../../environments/environment';
import { BusOtherKpFilterService } from '../../../services/bus-other-kp-filter.service';
import { CustomerListFilter } from '../../../models/customer-list-filter';
import { LoggingService } from '../../../../../services/logging.service';

const apiServer = environment.apiServer;
const controller = '/otherKp';
declare var $: any;

class DataTablesResponse {
  data: any[];
  draw: number;
  recordsFiltered: number;
  recordsTotal: number;
}

@Component({
  selector: 'app-other-kp-main-modal-customer',
  templateUrl: './other-kp-main-modal-customer.component.html',
  styleUrls: ['./other-kp-main-modal-customer.component.sass']
})
export class OtherKpCustomersComponent implements OnInit, OnDestroy, AfterViewInit {

  private subs: any[] = [];

  @ViewChild(DataTableDirective) datatableElement: DataTableDirective;
  @ViewChildren('nameInput') nameInputModel: QueryList<any>;

  checkedDistributerMember: number[];

  dt: DataTables.Api;
  modelCustomerFilter: CustomerListFilter = new CustomerListFilter();
  modelAuctionFilter: OtherKpFilter = new OtherKpFilter();
  dtOptionsCustomerMembers: DataTables.Settings = {};
  dataSetCustomers: any;

  private opened = false;

  constructor(private http: HttpClient, private bus: BusOtherKpFilterService, private loggingService: LoggingService, private cd: ChangeDetectorRef) {
    this.checkedDistributerMember = [];
  }

  ngOnInit() {
    const that = this;

    $('#modalOtherKpCustomer').off('shown.bs.modal').on('shown.bs.modal', function () {
      if (!that.opened) {
        that.opened = true;
        that.dt.ajax.reload();
      }
    });
    
    this.subs.push(
      this.bus.currentClearModalFilter$
        .pipe(skip(1))  // При инициализации фильтр уже очищен
        .subscribe(key => {
          if (key === 'customer') {
            this.nameInputModel.forEach(function (item) {
              item.nativeElement.checked = false;
            });
            this.checkedDistributerMember = [];
            this.onAuctionFilter('member');
          }
        })
    );

    this.subs.push(this.bus.currentClearSearchModalFields$.subscribe(key => {
      if (key === 'customerMemberName') {
        console.log(key);
        this.modelCustomerFilter.name = null;
        this.onFieldChange();
      }
    }));

    this.dtOptionsCustomerMembers = {
      pagingType: 'full_numbers',
      pageLength: 100,
      serverSide: true,
      processing: true,
      autoWidth: false,
      dom: 'tip',
      order: [1],
      deferLoading: 0,
      language: {
        emptyTable: 'Нет данных',
        info: 'Отображено с _START_ по _END_ из _TOTAL_ записей',
        infoEmpty: 'Отображено с 0 по 0 из 0 записей',
        infoFiltered: '(отфильтровано из _MAX_ записей)',
        infoPostFix: '',
        thousands: ',',
        lengthMenu: 'Показывать по _MENU_ записей',
        loadingRecords: 'Загрузка ...',
        processing: 'Обработка ...',
        search: 'Поиск:',
        zeroRecords: '',
        paginate: {
          first: 'Первая',
          last: 'Последняя',
          next: 'След.',
          previous: 'Пред.'
        },
        aria: {
          sortAscending: ': activate to sort column ascending',
          sortDescending: ': activate to sort column descending'
        }
      },
      ajax: (dataTablesParameters: any, callback) => {

        dataTablesParameters.search = this.modelCustomerFilter.name;

        that.http.post<DataTablesResponse>(`${apiServer + controller}/customersList`, dataTablesParameters, {})
          .subscribe(resp => {
            that.dataSetCustomers = resp.data;
            callback({
              recordsTotal: resp.recordsTotal,
              recordsFiltered: resp.recordsFiltered,
              data: []
            });
            that.cd.detectChanges();
          });
      },
      columns: [
        { orderable: false },
        { data: 'distrName', name: 'distrName' },
      ]
    };

  }

  ngOnDestroy() {
    this.subs.forEach(sub => sub.unsubscribe());
  }

  onFieldChange() {
    const _xid = this.loggingService.generateUUID();
    
    try {
      this.loggingService.logStart(_xid, 'App.Components.OtherKpCustomersComponent.onFieldChange', null, 'Field change started');
      
      this.dt.ajax.reload();
      
      this.loggingService.logFinish(_xid, 'App.Components.OtherKpCustomersComponent.onFieldChange', null, 'Field change completed');
    } catch (_error) {
      this.loggingService.logError(_xid, 'App.Components.OtherKpCustomersComponent.onFieldChange', _error, null, 'Field change failed');
      throw _error;
    }
  }
  onSelectedRowMember(event, value) {
    const _xid = this.loggingService.generateUUID();
    
    try {
      this.loggingService.logStart(_xid, 'App.Components.OtherKpCustomersComponent.onSelectedRowMember', null, 'Row selection started');
      
      if (event.target.checked) {
        this.checkedDistributerMember.push(value);
      } else {
        for (let i = 0; i < this.checkedDistributerMember.length; i++) {
          if (this.checkedDistributerMember[i] === value) {
            this.checkedDistributerMember.splice(i, 1);
          }
        }
      }
      
      this.loggingService.logFinish(_xid, 'App.Components.OtherKpCustomersComponent.onSelectedRowMember', null, 'Row selection completed');
    } catch (_error) {
      this.loggingService.logError(_xid, 'App.Components.OtherKpCustomersComponent.onSelectedRowMember', _error, null, 'Row selection failed');
      throw _error;
    }
  }
  onSelectingRowsMember(event) {
    const _xid = this.loggingService.generateUUID();
    
    try {
      this.loggingService.logStart(_xid, 'App.Components.OtherKpCustomersComponent.onSelectingRowsMember', null, 'Selecting all rows started');
      
      const that = this;

      this.nameInputModel.forEach(function (item) {
        item.nativeElement.checked = event.target.checked;

        if (event.target.checked) {
          that.checkedDistributerMember.push(that.dataSetCustomers.find(el => el.name == item.nativeElement.value)?.customerId);
        } else {
          for (let i = 0; i < that.checkedDistributerMember.length; i++) {
            if (that.checkedDistributerMember[i] == that.dataSetCustomers.find(el => el.name == item.nativeElement.value)?.customerId) {
              that.checkedDistributerMember.splice(i, 1);
            }
          }
        }
      });
      
      this.loggingService.logFinish(_xid, 'App.Components.OtherKpCustomersComponent.onSelectingRowsMember', null, 'Selecting all rows completed');
    } catch (_error) {
      this.loggingService.logError(_xid, 'App.Components.OtherKpCustomersComponent.onSelectingRowsMember', _error, null, 'Selecting all rows failed');
      throw _error;
    }
  }

  onAuctionFilter(selectedType: string) {
    const _xid = this.loggingService.generateUUID();
    
    try {
      this.loggingService.logStart(_xid, 'App.Components.OtherKpCustomersComponent.onAuctionFilter', null, 'Auction filter started');
      
      switch (selectedType) {
        case 'member':
          {
            this.modelAuctionFilter.customer = this.checkedDistributerMember.join(",");
            break;
          }
      }

      this.bus.changeFilter(this.modelAuctionFilter);
      
      this.loggingService.logFinish(_xid, 'App.Components.OtherKpCustomersComponent.onAuctionFilter', null, 'Auction filter completed');
    } catch (_error) {
      this.loggingService.logError(_xid, 'App.Components.OtherKpCustomersComponent.onAuctionFilter', _error, null, 'Auction filter failed');
      throw _error;
    }
  }

  ngAfterViewInit(): void {
    this.datatableElement.dtInstance.then((dtInstance: DataTables.Api) => {
      this.dt = dtInstance;
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/other-kp/component/other-kp-main/other-kp-main-modal-customer/other-kp-main-modal-customer.component.ts